import { initialize, localStoragePersister } from "@mindlercare/auth";
import { getCountryCode } from "../helpers/getCountryCode";

export const auth = initialize({
  stage: import.meta.env.VITE_STAGE,
  market: getCountryCode(),
  platform: "web",
  persister: localStoragePersister,
});
